export const areas = {
    land: "l", 
    island1: "1",
    island2: "2", 
    sea: "s"
};

export const groundTypes = {
    ground: [areas.land, areas.island1, areas.island2], 
    sea: [areas.sea], 
    all: [areas.land, areas.island1, areas.island2, areas.sea]
};

export const unitTypes = {
    troop: "troop",
    jet: "jet",
    boat: "boat",
    bomb: "bomb",
    flag: "flag",
    ship: "ship"
};

export const gameStages = {
    prepStage: 'prepStage',
    gameStage: 'gameStage'
};

export const gameStageTitles = {
    'prepStage': 'Prep Stage',
    'gameStage': 'Game Stage'
}
export const colors = {
    green: 'green',
    yellow: 'yellow',
    red: 'red'
}
export const actionColors = {
    move: colors.green,
    attack: colors.red,
    load: colors.yellow,
    unload: colors.yellow
};

export const board = [
    "ssssssssssssssssssss",
    "ssssssssllsslsslssss",
    "ssssslssllssllllllss",
    "ssssslllllslllllllss",
    "sssssslllllllllllsss",
    "ssissslllllllllllsss",
    "ssiisssllllllllsssss",
    "ssiiissllllllllllsss",
    "ssssssslllllllllssss",
    "ssssssssssssslllssss",
    "ssssssssssssslllssss",
    "ssssssslllllllllssss",
    "ssiiissllllllllllsss",
    "ssiisssllllllllsssss",
    "ssissslllllllllllsss",
    "sssssslllllllllllsss",
    "ssssslllllslllllllss",
    "ssssslssllssllllllss",
    "ssssssssllsslsslssss",
    "ssssssssssssssssssss"
];

/* Units Section - defining all units properties and behaviors. */
/* Types Objects*/
function flagObject(team){
    let obj = {};
    // General Information
    obj.type = unitTypes.flag;
    obj.id = "flag";
    obj.name = "Flag";
    obj.isVehicle = false;
    obj.team = team;
    obj.static = true;
    // Where can it go or be placed
    obj.prepPlacements = [areas.land];
    obj.moveOn = groundTypes.ground;
    // Carriable section
    obj.carriableByTroops = [false, true];
    obj.carriableByVehicles = [false, false];
    return obj;
}

function bombObject(team, id){
    let obj = {};
    // General Information
    obj.type = unitTypes.bomb;
    obj.team = team;
    obj.id = id;
    obj.isVehicle = false;
    obj.static = true;
    // Carriable section
    obj.carriableByTroops = [false, false];
    obj.carriableByVehicles = [true, false];
    return obj;
}

function jetObject(team, id){
    let obj = {};
    // General Information
    obj.type = unitTypes.jet;
    obj.team = team;
    obj.id = id;
    obj.isVehicle = true;
    obj.static = false;
    obj.seaHighTier = false;
    // Where can it go or be placed
    obj.prepPlacements = [areas.sea];
    obj.moveOn = groundTypes.all;
    // Runtime variables
    obj.unitsCurrentlyLoaded = [];
    // Vehicle stats
    obj.canCarryFlag = false;
    return obj;
}

function seaVehicleObject(team, id){
    let obj = {};
    // General Information
    obj.team = team;
    obj.id = id;
    obj.static = false;
    obj.seaHighTier = false;
    obj.isVehicle = true;
    // Where can it go or be placed
    obj.prepPlacements = [areas.sea];
    obj.moveOn = groundTypes.sea;
    // Runtime variables
    obj.unitsCurrentlyLoaded = [];
    // Vehicle stats
    obj.canCarryFlag = true;
    return obj;
}

function troopObject(team, id){
    let obj = {};
    // General information
    obj.type = unitTypes.troop;
    obj.id = id;
    obj.isVehicle = false;
    obj.team = team;
    obj.static = false;
    obj.groundHighTier = false;
    // Where can it go or be placed
    obj.prepPlacements = [areas.island1, areas.island2, areas.land];
    obj.moveOn = groundTypes.ground;
    // Troop specialties
    obj.canDefuseLandmines = false;
    obj.canDefuseSeamines = false;
    // Troop inventory
    obj.unitsCurrentlyLoaded = [];
    obj.isCarryingFlag = false;
    return obj;
}

/* Utilities */
function groundBombObject(team){
    let obj = bombObject(team, "groundBomb");
    obj.name = "Ground Bomb";
    obj.groundLevel = 0;
    // Where can it go or be placed
    obj.prepPlacements = [areas.land, areas.island1, areas.island2];
    obj.moveOn = groundTypes.ground;
    return obj;
}

function seaBombObject(team){
    let obj = bombObject(team, "seaBomb");
    obj.name = "Sea Bomb";
    obj.groundLevel = 0;
    obj.seaLevel = 0;
    // Where can it go or be placed
    obj.prepPlacements = [areas.sea, areas.land, areas.island1, areas.island2];
    obj.moveOn = groundTypes.all;
    return obj;
}

/* Jets */

function flyingJetObject(team){
    let obj = jetObject(team, "flyingJet");
    obj.name = "Flying Jet";
    // General Information
    obj.groundLevel = 1;
    obj.seaLevel = 1;
    // Vehicle props
    obj.capacity = [
        {by: 'type', name: unitTypes.troop, count: 2},
        {by: 'type', name: unitTypes.bomb, count: 1}
    ];
    return obj;
}

function battleJetObject(team){
    let obj = jetObject(team, "battleJet");
    obj.name = "Battle Jet";
    // General Information
    obj.groundLevel = 2;
    obj.seaLevel = 2;
    // Vehicle props
    obj.capacity = [
        {by: 'type', name: unitTypes.troop, count: 5},
        {by: 'type', name: unitTypes.bomb, count: 1}
    ];
    return obj;
}

/* Ship and boats */
function lifeboatObject(team){
    let obj = seaVehicleObject(team, "lifeboat");
    obj.name = "Lifeboat";
    // General Information
    obj.type = unitTypes.boat;
    obj.seaLevel = 3;
    // Vehicle props
    obj.capacity = [
        {by: 'type', name: unitTypes.troop, count: 2}
    ];
    return obj;
}

function spyBoatObject(team){
    let obj = seaVehicleObject(team, "spyBoat");
    obj.name = "Spy Boat";
    // General Information
    obj.type = unitTypes.boat;
    obj.seaLevel = 4;
    // Vehicle props
    obj.capacity = [
        {by: 'type', name: unitTypes.troop, count: 4},
        {by: 'type', name: unitTypes.bomb, count: 1}
    ];
    return obj;
}

function m4ShipObject(team){
    let obj = seaVehicleObject(team, "m4Ship");
    obj.name = "M4 Ship";
    // General Information
    obj.type = unitTypes.ship;
    obj.seaLevel = 5;
    // Vehicle props
    obj.capacity = [
        {by: 'type', name: unitTypes.boat, count: 1},
        {by: 'type', name: unitTypes.troop, count: 4},
        {by: 'type', name: unitTypes.bomb, count: 1}
    ];
    return obj;
}

function m7ShipObject(team){
    let obj = seaVehicleObject(team, "m7Ship");
    obj.name = "M7 Ship";
    // General Information
    obj.type = unitTypes.ship;
    obj.seaLevel = 6;
    obj.seaHighTier = true;
    // Vehicle props
    obj.capacity = [
        {by: 'type', name: unitTypes.boat, count: 1},
        {by: 'type', name: unitTypes.troop, count: 4},
        {by: 'type', name: unitTypes.bomb, count: 1},
        {by: 'id', name: 'flyingJet', count: 1},
    ];
    return obj;
}

/* Troops */
function groundDefuserTroopObject(team){
    let obj = troopObject(team, "groundDefuserTroop");
    obj.name = "Ground Defuser";
    // General information
    obj.groundLevel = 3;
    // Where can it go or be placed
    obj.prepPlacements = [areas.land, areas.island1, areas.island2];
    obj.moveOn = groundTypes.ground;
    // Troop specialties
    obj.groundHighTier = true;
    obj.canDefuseLandmines = true;
    return obj;
}

function seaDefuserTroopObject(team){
    let obj = troopObject(team, "seaDefuserTroop");
    obj.name = "Sea Defuser";
    // General information
    obj.groundLevel = 4;
    obj.seaLevel = 6;
    // Where can it go or be placed
    obj.prepPlacements = [areas.sea, areas.land, areas.island1, areas.island2];
    obj.moveOn = groundTypes.all;
    // Troop specialties
    obj.canDefuseSeamines = true;
    obj.seaHighTier = true;
    return obj;
}

function corporalTroopObject(team){
    let obj = troopObject(team, "corporalTroop");
    obj.name = "Corporal";
    // General information
    obj.groundLevel = 5;
    return obj;
}

function sergeantTroopObject(team){
    let obj = troopObject(team, "sergeantTroop");
    obj.name = "Sergeant";
    // General information
    obj.groundLevel = 6;
    return obj;
}

function firstSergeantTroopObject(team){
    let obj = troopObject(team, "firstSergeantTroop");
    obj.name = "First Sergeant";
    // General information
    obj.groundLevel = 7;
    return obj;
}

function lieutenantTroopObject(team){
    let obj = troopObject(team, "lieutenantTroop");
    obj.name = "Lieutenant";
    // General information
    obj.groundLevel = 8;
    return obj;
}

function captainTroopObject(team){
    let obj = troopObject(team, "captainTroop");
    obj.name = "Captain";
    // General information
    obj.groundLevel = 9;
    return obj;
}

function majorTroopObject(team){
    let obj = troopObject(team, "majorTroop");
    obj.name = "Major";
    // General information
    obj.groundLevel = 10;
    return obj;
}

function colonelTroopObject(team){
    let obj = troopObject(team, "colonelTroop");
    obj.name = "Colonel";
    // General information
    obj.groundLevel = 11;
    return obj;
}

function generalTroopObject(team){
    let obj = troopObject(team, "generalTroop");
    obj.name = "General";
    // General information
    obj.groundLevel = 12;
    return obj;
}

function marshallTroopObject(team){
    let obj = troopObject(team, "marshallTroop");
    obj.name = "Marshall";
    // General information
    obj.groundLevel = 13;
    obj.groundHighTier = true;
    return obj;
}
function unknownUnitObject(team){
    return {
        id: "unknown",
        name: "Unknown Unit",
        team: team,
        unitsCurrentlyLoaded: [],
    };
}
export const units = {
    flagObject,
    groundBombObject,
    seaBombObject,
    flyingJetObject,
    battleJetObject,
    lifeboatObject,
    spyBoatObject,
    m4ShipObject,
    m7ShipObject,
    groundDefuserTroopObject,
    seaDefuserTroopObject,
    corporalTroopObject,
    sergeantTroopObject,
    firstSergeantTroopObject,
    lieutenantTroopObject,
    captainTroopObject,
    majorTroopObject,
    colonelTroopObject,
    generalTroopObject,
    marshallTroopObject,
    unknownUnitObject
};

export const starterUnits = [
    // Troops
    { unit: seaDefuserTroopObject, default: 1, min: 1, max: 1 },
    { unit: groundDefuserTroopObject, default: 1, min: 1, max: 1 },
    { unit: corporalTroopObject, default: 5, min: 2, max: 5 },
    { unit: sergeantTroopObject, default: 5, min: 2, max: 5 },
    { unit: firstSergeantTroopObject, default: 4, min: 2, max: 4 },
    { unit: captainTroopObject, default: 3, min: 1, max: 3 },
    { unit: majorTroopObject, default: 3, min: 1, max: 3 },
    { unit: colonelTroopObject, default: 2, min: 1, max: 2 },
    { unit: generalTroopObject, default: 1, min: 1, max: 1 },
    { unit: marshallTroopObject, default: 1, min: 1, max: 1 },
    // Vehicles
    { unit: battleJetObject, default: 2, min: 1, max: 3 },
    { unit: flyingJetObject, default: 2, min: 1, max: 3 },
    { unit: m4ShipObject, default: 2, min: 1, max: 3 },
    { unit: m7ShipObject, default: 2, min: 1, max: 3 },
    { unit: spyBoatObject, default: 4, min: 0, max: 4 },
    { unit: lifeboatObject, default: 3, min: 1, max: 4 },
    // Bombs & Flag
    { unit: flagObject, default: 1, min: 1, max: 1 },
    { unit: seaBombObject, default: 3, min: 0, max: 4 },
    { unit: groundBombObject, default: 3, min: 0, max: 4 }
];

export const objectives =  {
    prep1: "Place all units",
    prep2: "Validate unit positions",
    prep3: "Send ready signal",
    prep4: "Wait until opponent is ready",
    gameSelf1: "Make your move",
    gameSelf2: "Evacuate units via lifeboat",
    gameSelf3: "Reposition your flag in a valid location",
    gameOp1: "Wait for opponent's move",
    gameOp2: "Wait for opponent's lifeboat evacuation",
    gameOp3: "Wait for opponent's flag reposition",
    gameOp4: "Wait for opponent's reconnection to match",
};
